<script setup>
  import { useGoogleAnalyticsStore } from '@/stores/GoogleAnalyticsStore';
  import useSettingsGlobals from '@/composables/useSettingsGlobals';
  import useSecureUrls from '@/composables/useSecureUrls';

  const googleAnalyticsStore = useGoogleAnalyticsStore();

  const { $WEB_VIEW, $PLATFORM } = useSettingsGlobals();
  const { upgradeUrl } = useSecureUrls();

  const props = defineProps({
    buttonText: {
      type: String,
      required: true
    },
    clickLocation: {
      type: String,
      default: ''
    }
  })

  const trackUpgradeClick = () => {
    googleAnalyticsStore.sendEvent('Upgrade_Clicked', {
      Click_Location: props.clickLocation,
    });
  }

  function handleUpgradeClick(e) {
    trackUpgradeClick();

    // TODO: Make composable
    // Android uses "membership-required" and iOS uses "learn-more" to show the membership screen
    if ($WEB_VIEW) {
      if ($PLATFORM === "android") {
        const params = [
          "membership-required",
        ];

        alert(params.join(","));
      } else {
        const info = {
          type: "learn-more",
        };

        window.webkit.messageHandlers.observe.postMessage(info);
      }
    }    
  }
</script>

<template>
  <button
    v-if="$WEB_VIEW"
    @click.prevent="handleUpgradeClick"
    class="jwx-button jwx-button--pill jwx-upgrade-block__button"
  >{{ buttonText }}</button>
  <a
    v-else
    :href="upgradeUrl"
    target="_blank"
    class="jwx-button jwx-button--pill jwx-upgrade-block__button"
    @click="trackUpgradeClick"
  >{{ buttonText }}</a>
</template>